import { render, staticRenderFns } from "./gift-recipient-detail.vue?vue&type=template&id=0f59ef9d&scoped=true&"
import script from "./gift-recipient-detail.vue?vue&type=script&lang=js&"
export * from "./gift-recipient-detail.vue?vue&type=script&lang=js&"
import style0 from "./gift-recipient-detail.vue?vue&type=style&index=0&id=0f59ef9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f59ef9d",
  null
  
)

export default component.exports